// extracted by mini-css-extract-plugin
module.exports = {"preloader":"fXkxz","icon":"PQV3g","circle":"HmSWj","animate":"_7S4jy"};